import {useLazyQuery} from "@apollo/client";
import {useState} from "react";
import {FiPlus} from "react-icons/fi";

import Button from "@/components/button/Button.tsx";
import {ButtonVariant} from "@/components/button/Button.types.ts";
import {Icon} from "@/components/icon/Icon.tsx";
import {GQL_SLA_REPORTS_INFO, SLAReportsInfoResponse} from "@/lib/queries/reports.ts";
import {ScheduledReportUpdateDrawer} from "@/pages/reports/schedule/ScheduledReportUpdateDrawer.tsx";

export const NewScheduledReportButton = ({text, variant}: {text?: string; variant?: ButtonVariant}) => {
  const [loadData, {data, loading}] = useLazyQuery<SLAReportsInfoResponse>(GQL_SLA_REPORTS_INFO, {
    variables: {
      limit: 500,
      offset: 0,
    },
    fetchPolicy: "no-cache",
  });
  const [show, setShow] = useState(false);
  return (
    <>
      {show && data && (
        <ScheduledReportUpdateDrawer
          show={show}
          onClose={() => {
            setShow(false);
          }}
          slaReports={data.slaReports.items}
          users={data.currentAccountUsers}
        />
      )}
      <Button
        size="large"
        variant={variant}
        onClick={async () => {
          if (!data && !loading) {
            await loadData();
          }
          setShow(true);
        }}
      >
        <Icon icon={FiPlus} /> {text ?? "Create Scheduled Report"}
      </Button>
    </>
  );
};
